module.exports = __webpack_public_path__ + "img/140.5.b742fe28.png";